/**
 * Feature flag names. Must match the exact API flag names served by `api/feature-flags`
 * (see Core `FeatureFlagNames.cs`).
 */

/** RideOps tablet: asset hierarchy / unit queue prototype UI. */
export const RIDEOPS_ASSET_HIERARCHY_PROTOTYPE = "rideops__assetHierarchyPrototype";

/** RideOps v2 UI redesign — org/user availability via Core; local opt-in required on device. */
export const RIDEOPS_UI_V2 = "rideops__rideOpsUiV2";
